import Container from '@mui/material/Container';



export default function DownloadsPage() {

    return(
        <Container maxWidth="lg">
            <br/>
            <h2 style={{"textAlign": "center"}}>Downloads</h2>
            <br/><br/>
            <div className='row'>
                    <div className='col-md-8'>
                    <p>
                        The Vista Enhancer browser database is organized into five, strictly hierarchical, one-to-many levels:
                        <ul>
                            <li><b>LOCUS</b>: Genome assembly and element coordinates.</li>
                            <li><b>ELEMENT</b>: The contents of <b>LOCUS</b> plus the element sequence.</li>
                            <li><b>EXPERIMENT</b>: The contents of <b>ELEMENT</b> plus the plasmid backbone and embryonic state.</li>
                            <li><b>EMBRYO</b>: The contents of <b>EXPERIMENT</b> plus the embryo designations.</li>
                            <li><b>IMAGE</b>: The contents of <b>EMBRYO</b> plus image metadata.</li>
                        </ul>
                        The <b>ALLELIC CURATION</b> table links individual <b>EXPERIMENT</b> entries.
                    </p>
                    </div>
                    <div className='col-md-4'>
                    <h3>View project on</h3>
                    <a href='https://gitlab.com/egsb-mfgl/vista-data' target='_blank' rel='noreferrer'>
                        <img src='images/gitlab.png' alt='View project on GitLab' style={{width:"100%"}}></img>
                    </a>
                    </div>
                </div>
                <br/><br/>
                <div className='row'>
                    <h3 className='text-center'>Data Downloads</h3>
                    <br/><br/>
                    <div className='col-md-6'>
                        <p>
                            <h5>Main</h5>
                            <ul>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/experiments.tsv.gz'  rel='noreferrer'>experiments.tsv.gz</a> - one experiment per row; also contains fields relating to element and locus levels.</li>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/allelic_curation.tsv.gz'  rel='noreferrer'>allelic_curation.tsv.gz</a> - table of all experiment comparisons displayed at the bottom of Experiment pages on Vista Browser; users might want to use allelic_curation_munge.tsv.gz instead.</li>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/allelic_curation_munged.tsv.gz' rel='noreferrer'>allelic_curation_munged.tsv.gz</a> - table of all manually curated experiment comparisons along with relevant experiment data (coordinates, sequence, etc.).</li>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/images.tsv.gz' rel='noreferrer'>images.tsv.gz</a> - one image per row; also contains in fields relating to embryo level and experiment hierarchy</li>
                            </ul>
                        </p>
                    </div>
                    <div className='col-md-6'>
<p>
                            <h5>Supplementary</h5>
                            <ul>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/field_descriptions.tsv.gz'  rel='noreferrer'>field_descriptions.tsv</a> - descriptions of experiment, alleleic_curation and images fields.</li>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/tissue.dictionary.csv' rel='noreferrer'>tissue.dictionary.csv</a> - for translating tissue field of experiments into human-readable form.</li>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/allelic.dictionary.csv' rel='noreferrer'>allelic.dictionary.csv</a> - for translating rel_tissue field of allelic_curation into human-readable form.</li>
                            <li><a href='https://gitlab.com/egsb-mfgl/vista-data/-/raw/main/locus.tsv.gz' rel='noreferrer'>locus.tsv.gz</a> - experiments.tsv.gz reduced to LOCUS, based on reference alleles; good for genomic analyses asking 'was this locus observed to be active under any of the tested conditions"; same fields as experiments.tsv.gz.</li>
                            </ul>
                        </p>
                </div>
            </div>
        </Container>
    )
}